import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id;
  @Input() data;
  @Input() chartColors: any[];
  @Input() labels:  any[];
  @Input() yAxisLabelType: any;
  private destroy$ = new Subject<void>();
  
  ngOnChanges(changes: SimpleChanges): void {
    this.drawBarChart();
  }

  ngOnInit(): void {
    this.drawBarChart();
  }

  public drawBarChart() {
    let yAxisType = this.yAxisLabelType;
    let maxValue = this.data[0]?.data.reduce((a, b)=>Math.max(a, b)); 
    let interval =  Math.floor(maxValue / 15);
    Highcharts.setOptions({
      colors: this.chartColors,
    })
    const options: any = {
      chart: {
        height: 200,
        type: 'column'
      },
      credits: {
        enabled: false
      },
      title: {
        text: ''
      },
      xAxis: {
        lineWidth : 0,
        categories: this.labels,
        crosshair: true,
        title: {
          text: ''
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily:'Banana_R',
            color:'black',
            fontWeight:400,
            lineHeight:1.5
          },
        },
      },
      yAxis: {
        min: 0,
        minRange: 2,
        // tickInterval: interval,
        title: {
          text: ''
        },
        labels: {
          formatter: function(event) {
             return yAxisType=== 'percentage' ? [this.value] + '%' : yAxisType=== 'dollar' ? '$'+ [this.value] : [this.value] + '';
          }
        }
      },
      tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: this.data
    };
    Highcharts.chart(this.id, options);
  }   
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}